module.exports = __webpack_public_path__ + "img/command.f6084394.svg";